import Category from '../layout/Category/Category'

const Home = () => {


  return <Category />
}

export default Home
